import { render } from "./DewaelePotentialOffer.vue?vue&type=template&id=015408fa"
import script from "./DewaelePotentialOffer.vue?vue&type=script&lang=js"
export * from "./DewaelePotentialOffer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__